module.exports = {"amp":"&","apos":"'","gt":">","lt":"<","quot":"\""}


//////////////////
// WEBPACK FOOTER
// ./~/entities/maps/xml.json
// module id = 148
// module chunks = 1